import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/OrderDetails.css';
import { fetchOrder } from '../actions/payment';

const OrderDetailsPage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);
        const response = await fetchOrder(orderId);

        if (response && response.data && response.data.length > 0) {
          const fetchedOrderData = response.data.find(
            (item) => item.data.customerInfo.email === orderId
          );

          if (fetchedOrderData) {
            const {
              reference,
              createdAt,
              amount,
              status,
              data: orderData,
            } = fetchedOrderData;

            setOrder({
              ...orderData,
              reference,
              totalAmount: amount,
              status,
              orderDate: createdAt,
            });
            setError(null);
          } else {
            setOrder(null);
            setError('Order not found.');
          }
        } else {
          setOrder(null);
          setError('Order not found or an error occurred.');
        }
      } catch (err) {
        console.error('Error fetching order:', err);
        setError('Failed to fetch order details. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  if (loading) {
    return (
      <div className='order-page-container'>
        <div className='loading-state'>
          <div className='spinner'></div>
          <p>Loading order details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='order-page-container'>
        <div className='error-state'>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  const {
    customerInfo,
    productInfo,
    totalAmount,
    status,
    reference,
    orderDate,
  } = order || {};

  console.log('Order data:', status);

  const formattedDate = orderDate
    ? new Date(orderDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : 'N/A';

     const getHeaderContent = (orderStatus) => {
       switch (orderStatus) {
         case 'CONFIRMED':
           return {
             icon: '✅',
             title: 'Pre-Order Confirmed!',
             message:
               'Thank you for your pre-order. Your payment has been processed successfully.',
           };
         case 'SENT':
           return {
             icon: '📦',
             title: 'Order Processing',
             message: 'Your order is being processed and will be shipped soon.',
           };
         case 'FAILED':
           return {
             icon: '❌',
             title: 'Payment Failed',
             message:
               'Unfortunately, your payment could not be processed. Please try again.',
           };
         case 'NEW':
         default:
           return {
             icon: '⏳',
             title: 'Order Received',
             message:
               'Your order has been received and is awaiting payment confirmation.',
           };
       }
     };

     const headerContent = getHeaderContent(status);

  return (
    <div className='order-page-container'>
      <div className='order-details-card'>
        <div className='header-section'>
          <span className='icon-badge'>{headerContent.icon}</span>
          <div className='header-content'>
            <h1>{headerContent.title}</h1>
            <p>{headerContent.message}</p>
          </div>
        </div>

        <div className='status-section'>
          <h3>Order Status</h3>
          <div
            className={`status-badge status-${status|| 'new'}`}
          >
            {status|| 'N/A'}
          </div>
        </div>

        <div className='info-section'>
          <h3>Order Information</h3>
          <div className='info-grid'>
            <div className='info-item'>
              <strong>Order ID:</strong>
              <span>{orderId || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Order Reference:</strong>
              <span>{reference || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Order Date:</strong>
              <span>{formattedDate}</span>
            </div>
            <div className='info-item'>
              <strong>Total Amount:</strong>
              <span>₦{(totalAmount || 0).toLocaleString()}</span>
            </div>
          </div>
        </div>

        <div className='info-section'>
          <h3>Product Details</h3>
          <div className='info-grid'>
            <div className='info-item'>
              <strong>Model:</strong>
              <span>{productInfo?.model || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Color:</strong>
              <span>{productInfo?.color || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Quantity:</strong>
              <span>{productInfo?.quantity || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Pre-Order Amount:</strong>
              <span>
                ₦{(productInfo?.preorderAmount || 0).toLocaleString()}
              </span>
            </div>
          </div>
        </div>

        <div className='info-section'>
          <h3>Customer Information</h3>
          <div className='info-grid'>
            <div className='info-item'>
              <strong>Name:</strong>
              <span>
                {customerInfo?.firstName || 'N/A'} {customerInfo?.lastName}
              </span>
            </div>
            <div className='info-item'>
              <strong>Email:</strong>
              <span>{customerInfo?.email || 'N/A'}</span>
            </div>
            <div className='info-item'>
              <strong>Phone:</strong>
              <span>{customerInfo?.phone || 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPage;
